module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6rjQ2"))).then(() => module.bundle.root('ikE14'));